'use strict';

$ = jQuery;
validatorConfig();

$(document).ready(function () {

  var formOffer = $('.form-offer-single-step'),
      offerID = $('.jc-offer-header').data('id'),
      cityElement = formOffer.find('.city'),
      cpfCnpjElement = formOffer.find('.cpfcnpj'),
      cepElement = formOffer.find('.cep'),
      phoneElement = formOffer.find('.phone');

  var latitude = null,
      longitude = null;

  formValidateConfig(formOffer);
  validatorCep();
  validatorCpfCnpj();
  validatorPhone();
  maskCep(cepElement);
  maskPhone(phoneElement);
  maskCpfCnpj(cpfCnpjElement);
  loadCityByCep(cepElement, cityElement);
  loadDealershipByCity(cityElement);

  getLocationUser().then(function (coordinates) {
    latitude = coordinates['latitude'];
    longitude = coordinates['longitude'];
  });

  formOffer.submit(function (event) {
    event.preventDefault();

    var isCatalog = $('#is-catalog-model-bradesco').length != 0;

    var form = $(this),
        button = form.find('button[type="submit"]');

    var leadData = {
      fullName: form.find('[name="fullname"]').val(),
      name: form.find('[name="name"]').val(),
      surname: form.find('[name="surname"]').val(),
      email: form.find('.email').val(),
      phone: form.find('.phone').val(),
      cpfcnpj: form.find('.cpfcnpj').val(),
      cep: form.find('.cep').val(),
      dealership: form.find('.dealerships input:checked').val(),
      message: form.find('.message').val(),
      oferta: offerID,
      getParameters: encodeURIComponent(JSON.stringify(getUrlVars())),
      optIns: {},
      lgpd: []
    };

    if (leadData.fullName && leadData.fullName != '') {
      leadData.fullName = leadData.fullName.trim().replace(/( )+/g, ' ');
      leadData.name = leadData.fullName ? leadData.fullName.split(' ')[0].trim() : '';
      leadData.surname = leadData.fullName.indexOf(' ') !== -1 ? leadData.fullName.substr(leadData.fullName.indexOf(' ') + 1).trim() : '';
    }

    form.find(".jc-opt-in").each(function () {
      leadData.optIns[$(this).attr('name')] = $(this).prop('checked');
      if ($(this).prop('checked')) {
        leadData.lgpd.push([$(this).attr('name'), $(this).parents(".form-group").text().trim(), $(this).parents(".form-group").find('a') ? $(this).parents(".form-group").find('a').attr('href') : null]);
      }
    });

    if (form.valid()) {

      var buttonLabel = button.text();
      button.prop('disabled', true).html('<i class="fa fa-cog fa-spin fa-fw"></i> Enviando...');

      grecaptcha.enterprise.ready(function () {
        grecaptcha.enterprise.execute(ajaxHandler.siteKey, { action: 'save_lead' }).then(function (grecaptchaToken) {

          $.ajax({
            url: ajaxHandler.url_leads + "/api/jornaldocarro/v1/receive-callback",
            type: 'POST',
            data: {
              action: 'jc_ajax_offer_save_lead_single_step',
              lead: leadData,
              token: grecaptchaToken,
              is_catalog: isCatalog
            },
            success: function success(response) {
              if (response && response.success) {
                var leadID = response.data.leadID;

                send_offer_lead_success_events(offerID, leadID, 'Oferta');

                showThankYouMsg(response.data);
              } else {
                populateAndShowFormError(formOffer, response.data);
                button.prop('disabled', false).html(buttonLabel);
              }
            },
            error: function error(data) {
              showFormError(formOffer);
              button.prop('disabled', false).html(buttonLabel);
            }
          });
        });
      });
    }
  });
});

function showThankYouMsg(data) {
  var name = data.name,
      dealership = data.dealershipName,
      address = data.dealershipAddress,
      phone = data.dealershipPhone;

  var html = '<h1 class="h2 font-weight-bold text-primary">Obrigado, ' + name + '!</h1><p class="text-muted">Em breve você receberá um contato para conversar sobre as condições comerciais quepossibilitem o fechamento do negócio.</p><div class="pr-md-5"><h3 class="h6 text-uppercase font-weight-bold">' + dealership + '</h3><p class="h6 text-muted">' + address + '</p><p class="h6 mb-4">' + phone + '</p></div><a href="https://jornaldocarro.sydle.com/ofertas-0km/filtro-ofertas-0km/" class="btn btn-primary">Ver mais ofertas</a>';

  $('.card-body').children().remove();
  $('.card-body').append(html);

  var pixelMeta = '\n  <script>\n  !function(f,b,e,v,n,t,s)\n  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n  n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';\n  n.queue=[];t=b.createElement(e);t.async=!0;\n  t.src=v;s=b.getElementsByTagName(e)[0];\n  s.parentNode.insertBefore(t,s)}(window,document,\'script\',\n  \'https://connect.facebook.net/en_US/fbevents.js\');\n  fbq(\'init\', \'755462965246201\');\n  fbq(\'track\', \'Lead\');\n  </script>\n  <noscript>\n  <img height="1" width="1"\n  src="https://www.facebook.com/tr?id=755462965246201&ev=PageView\n  &noscript=1"/>\n  </noscript>\n  ';
  $('head').append(pixelMeta);
}

function ThankYouBradesco() {
  var html = '<h1 class="h2 font-weight-bold text-primary">Obrigado!</h1><p class="text-muted">Em breve você receberá um contato para conversar sobre as condições comerciais quepossibilitem o fechamento do negócio.</p><div class="d-flex justify-content-center"><button type="button" class="autoline-redirect btn btn-bradesco btn-block w-auto"><a target="_blank" href="https://www.autoline.com.br/simular-financiamento">Simular Financiamento</a></button></div>';

  $('.card-body').children().remove();
  $('.card-body').append(html);
}

function ThankYouBradescoLP() {
  var html = '<div class="form-align-bbf"><h1 class="h2 font-weight-bold text-primary text-center">Obrigado!</h1><p class="text-muted text-center">Em breve você receberá um contato para conversar sobre as condições comerciais que possibilitem o fechamento do negócio.</p></div>';

  $('.form-section').children().remove();
  $('.form-section').append(html);
}